const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/refunds.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/refunds")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});